export const sliderData = [
  // Service - Custom Software Development
  { 
    title: "Custom Software Development", 
    desc: "Tailor-made enterprise software, CRM, ERP systems built to scale with your business needs. We deliver high-quality, scalable solutions that drive business growth.", 
    icon: "fas fa-laptop-code",
    category: "service",
    tag: "Premium Service",
    cta: "Explore Services",
    color: "#3b82f6"
  },
  
  // Product - English Language Lab
  { 
    title: "English Language Lab", 
    desc: "Digital platform to improve English communication skills with interactive lessons, audio exercises, and real-time assessments. Perfect for students and professionals.", 
    icon: "fas fa-language",
    category: "product",
    tag: "Featured Product",
    cta: "Learn More",
    color: "#10b981"
  },
  
  // Service - AI Consulting & Integration
  { 
    title: "AI Consulting & Integration", 
    desc: "LLM integration, computer vision, predictive analytics for business transformation. Harness the power of artificial intelligence.", 
    icon: "fas fa-robot",
    category: "service",
    tag: "AI Powered",
    cta: "Get AI Solutions",
    color: "#8b5cf6"
  },
  
  // Product - College & School ERP System
  { 
    title: "College & School ERP System", 
    desc: "Complete ERP solution to manage student records, attendance, fees, exams, and administrative tasks in one unified platform.", 
    icon: "fas fa-school",
    category: "product",
    tag: "Enterprise Solution",
    cta: "View Demo",
    color: "#f59e0b"
  },
  
  // Service - Mobile & Web Applications
  { 
    title: "Mobile & Web Applications", 
    desc: "React, Flutter, cross-platform high-performance apps for iOS, Android, and Web. End-to-end mobile app development.", 
    icon: "fas fa-mobile-alt",
    category: "service",
    tag: "Cross Platform",
    cta: "View Solutions",
    color: "#06b6d4"
  },
  
  // Product - E-Commerce Application
  { 
    title: "E-Commerce Application", 
    desc: "Complete online store solution with product listing, payment gateway integration, customer management, and order tracking.", 
    icon: "fas fa-shopping-cart",
    category: "product",
    tag: "Ready to Launch",
    cta: "Explore Now",
    color: "#ef4444"
  },
  
  // Service - Cybersecurity Solutions
  { 
    title: "Cybersecurity Solutions", 
    desc: "Security audits, penetration testing, and compliance management to protect your business from digital threats.", 
    icon: "fas fa-shield-alt",
    category: "service",
    tag: "Enterprise Security",
    cta: "Secure Now",
    color: "#14b8a6"
  },
  
  // Product - Library Management System
  { 
    title: "Library Management System", 
    desc: "Efficient library management with book cataloging, issue/return tracking, member management, and automated reports.", 
    icon: "fas fa-book",
    category: "product",
    tag: "Smart Solution",
    cta: "Discover",
    color: "#ec489a"
  },
  
  // Service - Bulk WhatsApp & SMS Marketing
  { 
    title: "Bulk WhatsApp & SMS Marketing", 
    desc: "Reach your audience instantly with automated bulk WhatsApp and SMS marketing campaigns for business growth.", 
    icon: "fab fa-whatsapp",
    category: "service",
    tag: "Marketing Tool",
    cta: "Start Campaign",
    color: "#25D366"
  },
  
  // Product - Online Exam System
  { 
    title: "Online Exam System", 
    desc: "Conduct exams digitally with multiple question types, automated evaluation, result generation, and performance analytics.", 
    icon: "fas fa-clipboard-list",
    category: "product",
    tag: "Assessment Tool",
    cta: "Try Demo",
    color: "#a855f7"
  },
  
  // Service - Digital Marketing & SEO
  { 
    title: "Digital Marketing & SEO", 
    desc: "Boost your online presence with expert SEO, social media marketing, and digital advertising strategies.", 
    icon: "fas fa-chart-line",
    category: "service",
    tag: "Growth Solution",
    cta: "Grow Business",
    color: "#f97316"
  },
  
  // Product - Employee Management System
  { 
    title: "Employee Management System", 
    desc: "Complete HR solution with employee records, attendance tracking, leave management, and payroll support.", 
    icon: "fas fa-users",
    category: "product",
    tag: "HR Solution",
    cta: "Learn More",
    color: "#6366f1"
  },
  
  // Service - Website Design & Development
  { 
    title: "Website Design & Development", 
    desc: "Professional website designing, redesigning, and responsive web solutions with modern technologies.", 
    icon: "fas fa-globe",
    category: "service",
    tag: "Web Solutions",
    cta: "Launch Website",
    color: "#3b82f6"
  },
  
  // Product - Feedback Management System
  { 
    title: "Feedback Management System", 
    desc: "Collect and analyze feedback from students, employees, or customers with customizable forms and reports.", 
    icon: "fas fa-comment-dots",
    category: "product",
    tag: "Insight Tool",
    cta: "Explore",
    color: "#06b6d4"
  },
  
  // Service - Internship & Training Programs
  { 
    title: "Internship & Training Programs", 
    desc: "Industry-ready training programs for students with hands-on projects, mentorship, and placement assistance.", 
    icon: "fas fa-graduation-cap",
    category: "service",
    tag: "Career Growth",
    cta: "Join Now",
    color: "#8b5cf6"
  },
  
  // Product - Digital Visiting Card
  { 
    title: "Digital Visiting Card", 
    desc: "Online business card with contact information, social media links, and QR code sharing for professionals.", 
    icon: "fas fa-id-card",
    category: "product",
    tag: "Digital Presence",
    cta: "Create Yours",
    color: "#f59e0b"
  }
];

export const features = [
  { icon: "fas fa-brain", title: "AI Integration", description: "Smart automation & ML models tailored for your business." },
  { icon: "fas fa-code", title: "Agile Development", description: "Rapid prototyping, CI/CD, and modern full-stack solutions." },
  { icon: "fas fa-chalkboard-user", title: "Expert Trainers", description: "Industry veterans with 10+ years of hands-on experience." },
  { icon: "fas fa-cloud-arrow-up", title: "Cloud Native", description: "AWS, Azure, GCP ready deployments with auto-scaling." },
  { icon: "fas fa-shield-alt", title: "Enterprise Security", description: "Bank-grade encryption & compliance standards." },
  { icon: "fas fa-chart-line", title: "Data Analytics", description: "Real-time insights & predictive analytics dashboards." }
];

export const stats = [
  { icon: "fas fa-trophy", value: "140+", title: "Clients Worldwide", description: "Global enterprises & startups" },
  { icon: "fas fa-graduation-cap", value: "8,000+", title: "Trained Professionals", description: "Skilled developers" },
  { icon: "fas fa-code-branch", value: "100+", title: "Projects Delivered", description: "Successful deployments" },
  { icon: "fas fa-star", value: "99%", title: "Client Satisfaction", description: "Rated excellent" }
];

export const servicesList = [
  { icon: "fas fa-laptop-code", title: "Custom Software Dev", description: "Tailor-made enterprise software, CRM, ERP systems." },
  { icon: "fas fa-mobile-alt", title: "Mobile & Web Apps", description: "React, Flutter, cross-platform high-performance apps." },
  { icon: "fas fa-robot", title: "AI Consulting", description: "LLM integration, computer vision, predictive analytics." },
  { icon: "fas fa-shield-alt", title: "Cybersecurity", description: "Security audits, penetration testing, compliance." },
  { icon: "fas fa-shield-alt", title: "Website Designing", description: "Website Designing and Redesigning" },
  { icon: "fas fa-shield-alt", title: "Software Development", description: "Software Development & Maintaince." },
  { icon: "fas fa-shield-alt", title: "Web Hosting", description: "Web Hosting & Maintaince." },
  { icon: "fas fa-shield-alt", title: "Bulk Whatsapp SMS", description: "Bulk Whatsapp SMS & Normal SMS." },
  { icon: "fas fa-shield-alt", title: "Bulk Voice Call", description: "Bulk Voice Call." },
  { icon: "fas fa-shield-alt", title: "SEO", description: "SEARCH ENGINE OPTIMIZATION." },
  { icon: "fas fa-shield-alt", title: "Interniship", description: "Interniship & Training Programmes for Students." }
];

export const products = [
  { icon: "fas fa-language", title: "English Language Lab", description: "An English Language Lab is a digital platform designed to improve students' English communication skills. It helps students practice listening, speaking, reading, and writing through interactive lessons, audio exercises, and assessments. Teachers can monitor student progress and provide personalized training." },
  { icon: "fas fa-school", title: "ERP System for Colleges and Schools", description: "A Library Management System helps schools, colleges, and institutions manage their library operations efficiently. It allows librarians to add books, issue and return books, track availability, manage members, and generate reports, making library management simple and organized." },
  { icon: "fas fa-book", title: "Library Management System", description: "An ERP (Enterprise Resource Planning) System integrates all academic and administrative activities of an institution into one platform. It manages student records, attendance, fees, exams, staff details, and reports, helping institutions operate smoothly and efficiently." },
  { icon: "fas fa-users", title: "Feedback Management System", description: "A Feedback Management System helps organizations collect and analyze feedback from students, employees, or customers. It allows users to submit feedback forms, evaluate responses, and generate reports to improve services and performance." },
  { icon: "fas fa-shopping-cart", title: "E-Commerce Application", description: "An E-Commerce Application allows businesses to sell products online. It provides features like product listing, online ordering, payment gateway integration, customer management, and order tracking, helping businesses reach more customers and increase sales." },
  { icon: "fas fa-clipboard-list", title: "Online Exam System", description: "An Online Exam System allows educational institutions and organizations to conduct exams digitally. It supports multiple question types, automated evaluation, result generation, and performance reports, making exams easy to manage and accessible from anywhere." },
  { icon: "fas fa-clipboard-list", title: "Digital Visiting Card", description: "A Digital Visiting Card is an online business card that allows professionals and businesses to share their contact information easily. It can include name, phone number, email, website, social media links, and company details, and can be shared instantly through a link or QR code." },
  { icon: "fas fa-clipboard-list", title: "Billing System", description: "A Billing System helps businesses generate invoices and manage transactions easily. It allows users to create bills, track payments, manage customers, and generate financial reports, making billing faster and more accurate." },
  { icon: "fas fa-clipboard-list", title: "Quotation Generator", description: "A Quotation Generator helps businesses quickly create professional quotations for customers. Users can add product details, pricing, taxes, and terms, and generate a quotation that can be shared with clients in digital format." },
  { icon: "fas fa-clipboard-list", title: "Employee Management System", description: "An Employee Management System helps companies manage employee information and activities efficiently. It includes features like employee records, attendance tracking, leave management, payroll support, and performance monitoring." },
  { icon: "fas fa-clipboard-list", title: "Job Portal", description: "A Job Portal is an online platform where employers can post job vacancies and job seekers can apply for jobs. It provides features like job posting, resume upload, candidate search, and application tracking, helping connect companies with potential employees." },
  { icon: "fas fa-clipboard-list", title: "Institute Management System", description: "An Institute Management System is designed to manage the daily operations of educational institutes. It helps handle student admissions, course management, attendance, fees, exams, and staff records, ensuring smooth administration and better organization." }
];

export const trainingPrograms = [
  { 
    icon: "fab fa-python", 
    title: "Full Stack AI Dev", 
    description: "React + FastAPI + GenAI | 12 weeks intensive",
    fullDescription: "Master the art of building AI-powered full-stack applications. Learn React for frontend, FastAPI for backend, and integrate cutting-edge Generative AI technologies. This comprehensive program covers everything from basic concepts to advanced AI integration, preparing you for real-world AI development challenges.",
    duration: "12 Weeks",
    level: "Intermediate to Advanced",
    highlights: ["React.js", "FastAPI", "Generative AI", "Full Stack Development"],
    curriculum: [
      "React.js Fundamentals & Hooks",
      "State Management with Redux",
      "FastAPI Backend Development",
      "Database Integration (PostgreSQL/MongoDB)",
      "Generative AI APIs (OpenAI, Anthropic)",
      "RAG (Retrieval Augmented Generation)",
      "Deployment & CI/CD",
      "Capstone Project"
    ],
    careerPaths: ["AI Full Stack Developer", "ML Engineer", "GenAI Specialist", "Technical Architect"],
    prerequisites: ["Basic Python Knowledge", "HTML/CSS Fundamentals", "JavaScript Basics"],
    badge: "AI Mentor Included"
  },
  { 
    icon: "fas fa-cloud", 
    title: "Cloud & DevOps", 
    description: "AWS, Kubernetes, Terraform | 8 weeks hands-on",
    fullDescription: "Become a certified DevOps engineer with hands-on training in cloud computing, containerization, and infrastructure automation. Learn industry-standard tools and practices used by top tech companies.",
    duration: "8 Weeks",
    level: "Intermediate",
    highlights: ["AWS", "Kubernetes", "Docker", "CI/CD"],
    curriculum: [
      "Linux Fundamentals",
      "Docker Containerization",
      "Kubernetes Orchestration",
      "AWS Services (EC2, S3, RDS, Lambda)",
      "Infrastructure as Code (Terraform)",
      "CI/CD Pipelines (Jenkins, GitHub Actions)",
      "Monitoring & Logging (Prometheus, Grafana)",
      "Real-world DevOps Projects"
    ],
    careerPaths: ["DevOps Engineer", "Cloud Architect", "SRE", "Platform Engineer"],
    prerequisites: ["Basic Linux Knowledge", "Command Line Experience"]
  },
  { 
    icon: "fas fa-chart-line", 
    title: "Data Science & ML", 
    description: "LLMs, LangChain, MLOps | 10 weeks capstone",
    fullDescription: "Master data science and machine learning with a focus on modern AI technologies including Large Language Models and MLOps practices. Build end-to-end ML solutions that drive business value.",
    duration: "10 Weeks",
    level: "Intermediate to Advanced",
    highlights: ["Python", "Machine Learning", "LLMs", "MLOps"],
    curriculum: [
      "Python for Data Science",
      "Statistical Analysis",
      "Machine Learning Algorithms",
      "Deep Learning (TensorFlow/PyTorch)",
      "Large Language Models (LLMs)",
      "LangChain Framework",
      "MLOps & Model Deployment",
      "Capstone Project"
    ],
    careerPaths: ["Data Scientist", "ML Engineer", "AI Specialist", "Data Analyst"],
    prerequisites: ["Python Basics", "Mathematics Fundamentals"]
  },
  { 
    icon: "fas fa-mobile-alt", 
    title: "Mobile Dev Bootcamp", 
    description: "React Native, Flutter | 6 weeks",
    fullDescription: "Build cross-platform mobile applications for iOS and Android using React Native and Flutter. Learn to create responsive, high-performance apps that deliver native-like experiences.",
    duration: "6 Weeks",
    level: "Beginner to Intermediate",
    highlights: ["React Native", "Flutter", "Cross-Platform", "App Store Deployment"],
    curriculum: [
      "Mobile Development Fundamentals",
      "React Native with Expo",
      "Flutter with Dart",
      "State Management",
      "API Integration",
      "Firebase Services",
      "App Store & Play Store Deployment",
      "Portfolio Projects"
    ],
    careerPaths: ["Mobile App Developer", "React Native Developer", "Flutter Developer", "Cross-Platform Specialist"],
    prerequisites: ["JavaScript Basics", "Programming Fundamentals"]
  },
  { 
    icon: "fas fa-mug-hot", 
    title: "Java Full Stack Development", 
    description: "Java Full Stack Development | 8 weeks",
    fullDescription: "Comprehensive Java Full Stack development training covering Spring Boot for backend and modern frontend technologies. Build enterprise-grade web applications from scratch.",
    duration: "8 Weeks",
    level: "Intermediate",
    highlights: ["Java", "Spring Boot", "React/Angular", "REST APIs"],
    curriculum: [
      "Core Java & OOP Concepts",
      "Advanced Java",
      "Spring Boot Framework",
      "RESTful API Development",
      "Frontend with React/Angular",
      "Database Design (MySQL/PostgreSQL)",
      "Security & Authentication",
      "Deployment & Testing"
    ],
    careerPaths: ["Java Developer", "Full Stack Developer", "Backend Engineer", "Software Engineer"],
    prerequisites: ["Basic Programming Knowledge"]
  },
  { 
    icon: "fas fa-book", 
    title: "Python Full Stack Development", 
    description: "Python Full Stack Development | 8 weeks",
    fullDescription: "Master Python full-stack development with Django/Flask for backend and modern frontend technologies. Learn to build scalable, secure web applications with Python.",
    duration: "8 Weeks",
    level: "Intermediate",
    highlights: ["Python", "Django/Flask", "React/Vue", "Databases"],
    curriculum: [
      "Python Programming",
      "Django & Flask Frameworks",
      "REST API Development",
      "Frontend with React",
      "Database Integration",
      "Authentication & Authorization",
      "Testing & Debugging",
      "Deployment & Cloud"
    ],
    careerPaths: ["Python Developer", "Full Stack Developer", "Backend Engineer", "API Developer"],
    prerequisites: ["Basic Python Knowledge"]
  },
  { 
    icon: "fas fa-book", 
    title: "PHP Full Stack Development", 
    description: "PHP Full Stack Development | 8 weeks",
    fullDescription: "Become a proficient PHP full-stack developer. Learn Laravel framework, modern frontend technologies, and database management to build dynamic web applications.",
    duration: "8 Weeks",
    level: "Beginner to Intermediate",
    highlights: ["PHP", "Laravel", "MySQL", "Frontend Integration"],
    curriculum: [
      "PHP Fundamentals",
      "Object-Oriented PHP",
      "Laravel Framework",
      "Database with MySQL",
      "Frontend with Vue.js",
      "REST API Development",
      "Security Best Practices",
      "CMS & E-commerce Development"
    ],
    careerPaths: ["PHP Developer", "Full Stack Developer", "Web Developer", "Laravel Specialist"],
    prerequisites: ["Basic HTML/CSS", "Programming Fundamentals"]
  },
  { 
    icon: "fas fa-code", 
    title: "Frontend Development", 
    description: "Frontend Development (HTML, CSS, JavaScript) | 8 weeks",
    fullDescription: "Master modern frontend development with HTML5, CSS3, and JavaScript. Learn to create responsive, interactive web applications with the latest frontend technologies.",
    duration: "8 Weeks",
    level: "Beginner",
    highlights: ["HTML5", "CSS3", "JavaScript", "React"],
    curriculum: [
      "HTML5 Semantic Markup",
      "CSS3 Flexbox & Grid",
      "JavaScript Fundamentals",
      "DOM Manipulation",
      "ES6+ Features",
      "Responsive Design",
      "Modern CSS (Tailwind/Bootstrap)",
      "Version Control (Git)",
      "Final Project"
    ],
    careerPaths: ["Frontend Developer", "UI Developer", "Web Designer", "React Developer"],
    prerequisites: ["Computer Basics", "Interest in Web Development"]
  },
  { 
    icon: "fas fa-laptop-code", 
    title: "Internship Program", 
    description: "Our IT Internship Program provides hands-on experience in real-world technology environments.",
    fullDescription: "Our IT Internship Program is designed to provide students and recent graduates with hands-on experience in real-world technology environments. Work on live projects, collaborate with industry experts, and build a professional portfolio.",
    duration: "3-6 Months",
    level: "Beginner to Intermediate",
    highlights: ["Live Projects", "Mentorship", "Industry Exposure", "Certificate"],
    curriculum: [
      "Real-world Project Work",
      "Code Reviews & Best Practices",
      "Agile Development Methodology",
      "Version Control & Collaboration",
      "Communication Skills",
      "Resume Building",
      "Interview Preparation",
      "Professional Portfolio Development"
    ],
    careerPaths: ["Junior Developer", "IT Trainee", "Associate Engineer", "QA Tester"],
    prerequisites: ["Completed or Pursuing Degree", "Basic Programming Knowledge"],
    badge: "Limited Seats"
  }
];

export const team = [
  { 
    name: "Mr. Santosh Katagi", 
    role: "Director", 
    img: "https://vtechcoders.com/team/santosh-vtech-coders-768x1023.png", 
    bio: "Senior Developer with 15+ years of experience in full-stack development and team leadership. Expert in React, Node.js, and Cloud Architecture.",
    whatsappNumber: "919886631818", // Replace with actual number
    email: "info@vtechcoders.com",
    expertise: ["Full Stack Development", "Team Leadership", "Cloud Architecture", "React", "Node.js"],
    achievements: [
      "Led 50+ successful projects",
      "Certified Master Degree",
      "Mentored 100+ developers",
      "Senior Developer"
    ]
  },
  { 
    name: "Mr. Zaheer N Hebballi", 
    role: "Director", 
    img: "https://vtechcoders.com/team/Zaheer-vtech-coders-2.png", 
    bio: "Senior Developer specializing in AI/ML solutions and enterprise software architecture. Passionate about innovation and technology.",
    whatsappNumber: "919986352227", // Replace with actual number
    email: "zaheer.myvertex@vtechcoders.com",
    expertise: ["AI/ML", "Enterprise Architecture", "Python", "Data Science", "Team Management"],
    achievements: [
      "Implemented AI solutions for 20+ enterprises",
      "Published research in ML",
      "Senior Developer",
      "AI Innovation Developer"
    ]
  },
  { 
    name: "Mr. Vinod M Katagi", 
    role: "Accounts & Operations", 
    img: "https://vtechcoders.com/team/Vinoad-vtech-coders-768x1024.png", 
    bio: "Office Management and Accounts professional with expertise in financial planning, operations.",
    whatsappNumber: "919972303374", // Replace with actual number
    email: "info@vtechcoders.com",
    expertise: ["Financial Management", "Operations",  "Strategic Office Planning", "Team Coordination"],
    achievements: [
      
      "Managed accounts ",
      "Financial Manager",
      
    ]
  },
  {
  name: "Shradha Devadiga",
  role: "Full Stack Developer",
  img: "https://vtechcoders.com/team/Shradha-Devadiga-VTECH-CODERS.jpeg",
  bio: "Full Stack Developer specializing in modern web application development, scalable backend systems, responsive user interfaces, and API integration.",
  whatsappNumber: "918123082430",
  email: "info@vtechcoders.com",
  expertise: [
    "Video Editing & Animation",
    "Motion Graphics",
    "PHP & MySQL",
    "REST API Development",
    "JavaScript",
    "Full Stack Web Development"
  ],
  achievements: [
    "Developed and deployed multiple full-stack web applications",
    "Built scalable REST APIs and database-driven applications",
    "Designed and integrated MySQL database-driven solutions",
    "Developed video, animation, and motion-graphics based digital content"
  ]
},
{
  name: "Spurthi S Pujar",
  role: "Full Stack Developer",
  img: "https://vtechcoders.com/team/Spurthi-S-Pujar-VTECH-CODERS.jpeg",
  bio: "Full Stack Developer specializing in modern web application development, scalable backend systems, responsive user interfaces, and API integration.",
  whatsappNumber: "919741212043",
  email: "info@vtechcoders.com",
  expertise: [
    "Data Analytics",
    "Data Visualization",
    "PHP & MySQL",
    "REST API Development",
    "JavaScript",
    "Database Management"
  ],
  achievements: [
    "Developed and deployed multiple full-stack web applications",
    "Built scalable REST APIs and database-driven applications",
    "Designed and integrated MySQL database-driven solutions",
    "Designed and integrated MySQL database-driven solutions",
"Created data analytics dashboards and interactive visualizations",
  ]
},
{
  name: "Anjali Basavaraj Kumbar",
  role: "Full Stack Developer",
  img: "https://vtechcoders.com/team/Anjali-Basavaraj-Kumbar-VTECH-CODERS.jpeg",
  bio: "Full Stack Developer specializing in modern web application development, scalable backend systems, responsive user interfaces, and API integration.",
  whatsappNumber: "919606713531",
  email: "info@vtechcoders.com",
  expertise: [
    "Data Analytics",
    "Motion Graphics",
    "PHP & MySQL",
    "REST API Development",
    "JavaScript",
    "Full Stack Web Development"
  ],
  achievements: [
    "Developed and deployed multiple full-stack web applications",
    "Built scalable REST APIs and database-driven applications",
    "Designed and integrated MySQL database-driven solutions",
    "Designed and integrated MySQL database-driven solutions",
"Created data analytics dashboards and interactive visualizations",
  ]
},
{
  name: "Saniya Khan",
  role: "Full Stack Developer",
  img: "https://vtechcoders.com/team/Saniya-Khan-VTECH_CODERS.jpeg",
  bio: "Full Stack Developer specializing in modern web application development, scalable backend systems, responsive user interfaces, and API integration.",
  whatsappNumber: "917483925656",
  email: "info@vtechcoders.com",
  expertise: [
    "Video Editing & Animation",
    "Motion Graphics",
    "PHP & MySQL",
    "REST API Development",
    "JavaScript",
    "Full Stack Web Development"
  ],
  achievements: [
    "Developed and deployed multiple full-stack web applications",
    "Built scalable REST APIs and database-driven applications",
    "Designed and integrated MySQL database-driven solutions",
    "Developed video, animation, and motion-graphics based digital content"
  ]
}
];

export const testimonials = [
  { text: "VTECH CODERS transformed our digital infrastructure. Their AI solutions increased efficiency by 40%.", name: "Dr. Meti Rudresh", role: "Adviser, MERU IAS & KAS STUDY" },
  { text: "The training program was exceptional. Our team is now fully equipped with modern AI skills.", name: "Dr. M.H. Jogi", role: "Founder, Elsta India" },
  { text: "Best software development partner we've ever worked with. Professional, innovative, and reliable.", name: "Mr. Shivayogi Aminagad", role: "Owner, Amingad Store" }
];